import getSemaphoreColor from './sempahore-colors';

export {getSemaphoreColor};
